import {ContextStateSymbol, ContextUpdateSymbol} from '@/components/global/Context.vue';
import {GENDERS} from "@/utils/constants";

export const requestValidation = {
    data() {
        return {
            isPasswordWrong: false,
            isNewPasswordSame: false,
            isEmailWrong: {
                wrong: false,
                taken: false,
                notVerified: false,
            },
            isNickWrong: {
                wrong: false,
                taken: false,
            },
            isLoginWrong: false,
        }
    },
}